import rmaReducer from "@store/Store/Pages/Rma/RmaReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    rma: rmaReducer,
};

export type PagesReducers = typeof pagesReducers;

const pagesReducer = combineReducers(pagesReducers as any);
export default pagesReducer;
